/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import apiClient from '../apiClient';
import { DelayedDownloadingsListItemDto } from './downloadingsClient.typings';

async function getDelayedDownloadings(): Promise<DelayedDownloadingsListItemDto[]> {
    return apiClient.get<DelayedDownloadingsListItemDto[]>('1.0.0/downloads');
}

async function deleteDelayedDownloadingsItem(ids: number[]): Promise<'OK'> {
    return apiClient.delete<'OK'>('1.0.0/downloads', { ids });
}

async function getUrlForDownloading(name: string): Promise<string> {
    return apiClient.get<string>('1.0.0/downloads/url', { name });
}

export const downloadingsClient = {
    getDelayedDownloadings,
    deleteDelayedDownloadingsItem,
    getUrlForDownloading,
};
